import React, { useContext } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import useMatchMedia from 'hooks/useMatchMedia';
import OnboardingContext from '../../../../providers/Onboarding/Onboarding.context';
import { MembersDesktop } from './components/MembersDesktop';
import { MembersMobile } from './components/MembersMobile';
import GroupChatSellSideCard from './components/GroupChatSellSideCard';

import './Members.styles.scss';
import './Members.styles.responsive.scss';

type MembersProps = {
  className?: string;
};

const Members: React.FC<MembersProps> = (props) => {
  const { className } = props;

  const { contentCard } = useContext(OnboardingContext);

  const isTablet = useMatchMedia('isTablet');

  const classes = classNames('members', 'page', className);

  const { t } = useTranslation();

  return (
    <div className={classes}>
      <h2>{t('dataRoomMembers')}</h2>
      <p>{t(`dataRoomMembersDescription${isTablet ? 'Mobile' : ''}`)}</p>
      {contentCard}

      <GroupChatSellSideCard />

      {isTablet ? <MembersMobile /> : <MembersDesktop />}
    </div>
  );
};

export default Members;
